import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { SeoMetaService } from '../../services/seo-meta-service';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { EventsService } from 'src/app/core/services/events.service';
import { RoutePlanerEventTracker, MobileNavigationEvent } from 'src/app/core/events/events';
import { Subscription } from 'rxjs';
import { IMobileNavigationEventModel, MobileMenuModel } from 'src/app/core/models/models';

declare var window: any;

export class BaseRouterComponent extends EventsService {
  public isDesktop = true;
  public routerType: AARouterURL;
  public mapMobileMenu: MobileMenuModel = new MobileMenuModel();

  private _observableSubscriptions: Subscription[] = [];

  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public appUtilityService: AppUtilityService,
    public seoService: SeoMetaService) {
    super();
    // Set intial value when app get loads in browser resolution
    this.isDesktop = this.appUtilityService.isDeviceCheck();

    // Window resize event listener - update the isDesktop value
    const subWRE = this.appUtilityService.windowResizeEmitter$.subscribe((data: any) => {
      this.isDesktop = this.appUtilityService.isDeviceCheck();
      this.onWindowResize();
    });
    this._observableSubscriptions.push(subWRE);

    // mobile event
    this.on(MobileNavigationEvent.MOBILE_MENU, this.mobileMenuTabHandler.bind(this));
  }

  public onWindowResize(): void { }

  public mobileMenuTabHandler(event: IMobileNavigationEventModel) {
    this.mapMobileMenu.setActiveMenu(event.ActiveTab);
  }

  public get observableSubscriptions(): Subscription[] {
    return this._observableSubscriptions;
  }
  public set observableSubscriptions(value: Subscription[]) {
    this._observableSubscriptions = value;
  }

  public trackEvent(): void {
    this.dispatch(RoutePlanerEventTracker.TAG_VIEW);
  }

  public get snapshot(): ActivatedRouteSnapshot {
    return this.activatedRoute.snapshot;
  }

  // load params & queryParams
  public loadParams() {
    this.trackEvent();

    this.activatedRoute.queryParams.subscribe(queryParams => {
      this.activatedRoute.params.subscribe(routeParams => {
        const params = { ...queryParams, ...routeParams };
        setTimeout(() => {
          this.initMap(params);
        }, 10);
      });
    });
  }

  public initMap(params: any): void { }

  public applySEO(): void {
    let currentLocation: any;
    let url: any;

    const _title = this.snapshot.data['title'];
    const _description = this.snapshot.data['description'];
    const _pageTitle = this.snapshot.data['pageTitle'];

    switch (this.routerType) {
      case AARouterURL.ROUTE_PLANNER:
        this.seoService.updateTitle(_title);
        this.seoService.updateDescription(_description);

        url = this.seoService.cononicalURL( AARouterURL.ROUTE_PLANNER );
        this.seoService.updateCanonicalURL(url);
        this.appUtilityService.pageTitle = _pageTitle;
        break;

      case AARouterURL.TRAFFIC_NEWS:
        currentLocation = this.getCurrentLocation();
        this.seoService.updateTitle(this.replaceLocationTocken(_title, currentLocation, true));
        this.seoService.updateDescription(this.replaceLocationTocken(_description, currentLocation));

        currentLocation = encodeURI(currentLocation);
        this.seoService.trafficNewsUpdateCanonicalURL(currentLocation);
        this.appUtilityService.pageTitle = _pageTitle;
        break;

      case AARouterURL.MAP_HOTELS:
        this.seoService.updateTitle(_title);
        this.seoService.updateDescription(_description);

        url = this.seoService.cononicalURL(AARouterURL.MAP_HOTELS, this.getCurrentLocation() );
        this.seoService.updateCanonicalURL( url );
        this.appUtilityService.pageTitle = _pageTitle;
        break;
    }
  }

  private getCurrentLocation(): any {
    return this.snapshot.params[AARouterURL._LOCATION];
  }

  private replaceLocationTocken(keyword: string, currentLocation: string, isExtraSpace: boolean = false): string {
    if (!currentLocation) {
      keyword = isExtraSpace ? keyword.replace('{LOCATION}', ' ') : keyword.replace('{LOCATION}', '');
    } else {
      keyword = keyword.replace('{LOCATION}', ' for ' + currentLocation);
    }
    return keyword;
  }

  public applySiteTag() {
    switch (this.routerType) {
      case AARouterURL.ROUTE_PLANNER:
        window.streamampClientConfig = { targets: { 'Pagetype': 'Route planner' } };
        break;

      case AARouterURL.TRAFFIC_NEWS:
        window.streamampClientConfig = { targets: { 'Pagetype': 'Traffic news' } };
        break;

      case AARouterURL.MAP_HOTELS:
        window.streamampClientConfig = { targets: { 'Pagetype': 'Maps and AA hotels' } };
        break;

      case AARouterURL.MILEAGE_CALCULATOR:
        window.streamampClientConfig = { targets: { 'Pagetype': 'Mileage calculator' } };
        break;

      case AARouterURL.WALKS_BIKES:
        window.streamampClientConfig = { targets: { 'Pagetype': 'Walks and Bike Rides' } };
        break;

      case AARouterURL.PRINT_PREVIEW:
        window.streamampClientConfig = { targets: { 'Pagetype': 'Print Preview' } };
        break;
    }
  }

  /**
   * Unsubscribe all registered observable subscriptions
   */
  public unSubscribeObservableEvents() {
    this._observableSubscriptions.forEach((s) => s.unsubscribe());
  }
}
